import { connect } from 'react-redux';
import RestrictContent from 'app/components/auth/RestrictContent';
import { getCurrentUserAbilities, isAuthenticatedSelector } from 'app/models/auth/selectors';
import { AppState } from 'app/store';

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: isAuthenticatedSelector(state),
  userAbilities: getCurrentUserAbilities(state),
});

export default connect(mapStateToProps)(RestrictContent);
